import React from "react";
import { Link } from "react-router-dom";
import "../CSS/ai.css";

function AISolutions() {
  return (
    <div className="ai-page">
      
      {/* ================= HERO ================= */}
      <section className="ai-hero">

        <div className="container">
          <div className="ai-hero-content">
            <h1>
              AI Solutions For<br />
              <span>
                Digital Business
              </span>
            </h1>

            <p>
              Explore AI-assisted video, image, and business solutions
              designed to help businesses create better content, improve
              productivity, and strengthen their digital presence.
            </p>
            <div className="about-hero-buttons">
              <Link to="/contactus" className="about-primary-button" >
                Let's Work Together
              </Link>
              <Link to="/services" className="about-secondary-button" >
                Explore Our Services
              </Link>
            </div>
          </div>
        </div>

      </section>


      {/* ================= INTRO ================= */}
      <section className="ai-intro-section">
        <div className="container">
          <div className="ai-sections-heading text-center">
            <h2>
              Smart AI Solutions for Growing Businesses
            </h2>

          </div>
        </div>
      </section>


      {/* ================= THREE SERVICES ================= */}
      <section className="ai-main-services">

        <div className="container">

          <div className="row g-4">

            {/* ================= VIDEO ================= */}
            <div className="col-lg-4">

              <div className="ai-main-card">

                <div className="ai-main-icon">
                  🎬
                </div>

                <h2>
                  AI Video Services
                </h2>

                <p>
                  AI-assisted video creation and editing services for
                  businesses, marketing campaigns, presentations,
                  social media, and digital content.
                </p>

                <ul>
                  <li>AI Video Creation</li>
                  <li>AI Video Editing</li>
                  <li>Marketing Videos</li>
                  <li>Social Media Videos</li>
                  <li>Business Videos</li>
                </ul>

                <Link
                  to="/ai/video-creator"
                  className="ai-main-button"
                >
                  Explore Video Services →
                </Link>

              </div>

            </div>


            {/* ================= IMAGE ================= */}
            <div className="col-lg-4">

              <div className="ai-main-card">

                <div className="ai-main-icon">
                  🖼️
                </div>

                <h2>
                  AI Image Services
                </h2>

                <p>
                  AI-assisted image creation and editing solutions for
                  websites, products, marketing campaigns, social media,
                  and digital branding.
                </p>

                <ul>
                  <li>AI Image Creation</li>
                  <li>Image Editing</li>
                  <li>Marketing Creatives</li>
                  <li>Product Visuals</li>
                  <li>Social Media Graphics</li>
                </ul>

                <Link
                  to="/ai/image-creator"
                  className="ai-main-button"
                >
                  Explore Image Services →
                </Link>

              </div>

            </div>


            {/* ================= BUSINESS ================= */}
            <div className="col-lg-4">

              <div className="ai-main-card">

                <div className="ai-main-icon">
                  🤖
                </div>

                <h2>
                  AI Business Solutions
                </h2>

                <p>
                  AI-assisted business solutions designed to improve
                  productivity, customer communication, automation,
                  and business processes.
                </p>

                <ul>
                  <li>AI Automation</li>
                  <li>AI Chatbots</li>
                  <li>AI Business Assistants</li>
                  <li>Document Solutions</li>
                  <li>Custom AI Solutions</li>
                </ul>

                <Link
                  to="/ai/business-solutions"
                  className="ai-main-button"
                >
                  Explore Business AI →
                </Link>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ================= WHY AI ================= */}
      <section className="ai-benefits-section">

        <div className="container">

          <div className="ai-sections-heading text-center">
            <h2>
              AI Technology Built Around Your Business Goals
            </h2>

          </div>


          <div className="row g-4 mt-4">

            <div className="col-lg-3 col-md-6">
              <div className="ai-benefit-card">

                <span>⚡</span>

                <h3>
                  Faster Workflows
                </h3>

                <p>
                  Use modern technology to simplify repetitive tasks
                  and improve productivity.
                </p>

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="ai-benefit-card">

                <span>💡</span>

                <h3>
                  Better Creativity
                </h3>

                <p>
                  Explore new ways to create digital content and
                  communicate your ideas.
                </p>

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="ai-benefit-card">

                <span>📈</span>

                <h3>
                  Business Growth
                </h3>

                <p>
                  Apply technology strategically to support business
                  operations and customer experiences.
                </p>

              </div>
            </div>


            <div className="col-lg-3 col-md-6">
              <div className="ai-benefit-card">

                <span>🔧</span>

                <h3>
                  Custom Solutions
                </h3>

                <p>
                  Solutions can be adapted according to your specific
                  business requirements.
                </p>

              </div>
            </div>

          </div>

        </div>

      </section>


      {/* ================= CTA ================= */}
      <section className="cta-section">

        <div className="container">

          <div className="cta-box">

            <div className="cta-content">

              <span className="ai-cta-label">
                START YOUR PROJECT
              </span>

              <h2>
                Have An AI Requirement?
              </h2>

              <p>
                Tell us about your idea, business requirement, or
                digital project and let's discuss the right solution.
              </p>

            </div>

            <Link
              to="/contactus"
              className="cta-button" style={{ textDecoration: 'none' }}
            >
              Get In Touch
            </Link>

          </div>

        </div>

      </section>

    </div>
  );
}

export default AISolutions;